import { axios, baseURL } from "@/plugins/axios.js";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    createCosting(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('api/v1/costings', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateCosting(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/api/v1/costings/${params.id}`, params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    voidCosting(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/api/v1/costings/${params.id}`, { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchCosting(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/v1/costings/${params.id}`, { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchCostings(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/costings', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchDocRefs(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/costings/doc_refs', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchSalesAnalytic(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/costings/sales_analytic', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchPM1Analytic(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/costings/toner_costings', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchBDAnalytic(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/costings/bodyshop_analytic', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchBDCostAnalytic(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/costings/bodyshop_costings', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    exportCostings(ctx, params) {
      return new Promise((resolve, reject) => {
        const urlParams = new URLSearchParams();
        urlParams.append("start_date", params.start_date || "");
        urlParams.append("end_date", params.end_date || "");
        urlParams.append("search_text", params.search_text || "");
        urlParams.append("costing_type_id", params.costing_type_id || "");
        urlParams.append("asset_id", params.asset_id || "");
        fetch(`${baseURL}/api/v1/costings/export.xlsx?${urlParams}`, {
          method: "GET",
          headers: Object.assign($cookies.get("userAuth"), { "Access-Control-Allow-Origin": "*" })
        })
          .then((response) => {
            resolve(response.blob());
          })
          .catch((error) => reject(error));
      });
    },
  }
}